import * as React from "react";

const Timer = (props: any) => {
    const { initialSeconds } = props;

    const [seconds, setSeconds] = React.useState(initialSeconds);

    React.useEffect(() => {
        let isMounted = true;

        if (seconds > 0) {
            setTimeout(() => {
                if (isMounted)
                    setSeconds(seconds - 1)
            }, 1000);
        } else {
            if (isMounted) {
                props.onFinishCount();
            }
        }

        return () => { isMounted = false }
    }, [seconds]);

    return (
        <div>
            {`${Math.floor(seconds / 60)}`.padStart(2, '0')}:{`${seconds % 60}`.padStart(2, '0')}
        </div>
    );
}

export default Timer;